import { render, staticRenderFns } from "./EventDetailErrorMessages.vue?vue&type=template&id=8c8b66a6&"
import script from "./EventDetailErrorMessages.vue?vue&type=script&lang=ts&"
export * from "./EventDetailErrorMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports